import { getCourseIcon } from '@/utils/courseIcons';

// Teacher's uploaded image if set, otherwise their chosen preset icon (default book)
export const CourseVisual = ({ course, className = '', iconClassName = 'h-6 w-6', iconColor = '#163329', bg = '#F0EFEA' }) => {
  const imageUrl = course?.thumbnail_url || course?.thumbnail;
  if (imageUrl) {
    return (
      <div className={`overflow-hidden ${className}`} data-testid={`course-visual-image-${course.id}`}>
        <img src={imageUrl} alt={course.title} className="w-full h-full object-cover" />
      </div>
    );
  }
  const Icon = getCourseIcon(course?.icon);
  return (
    <div className={`flex items-center justify-center ${className}`} style={{ backgroundColor: bg }} data-testid={`course-visual-icon-${course?.id}`}>
      <Icon className={iconClassName} style={{ color: iconColor }} />
    </div>
  );
};
